import React from 'react'

function ActiveFilterBar({ selectedPeople = [], filteredStoryCount = 0, onRemovePerson, onClearAll }) {
  if (selectedPeople.length === 0) return null

  return (
    <div className="bg-fb-olive/10 border border-fb-olive/20 rounded-lg px-4 py-3 flex items-center gap-3 flex-wrap">
      <span className="font-serif text-sm text-fb-olive font-semibold whitespace-nowrap">
        Showing stories from:
      </span>

      <div className="flex items-center gap-2 flex-wrap flex-1">
        {selectedPeople.map(person => (
          <span
            key={person.id}
            className="inline-flex items-center gap-1.5 bg-white border border-fb-olive/30 rounded-full pl-1 pr-2 py-0.5"
          >
            <span
              className="w-6 h-6 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0"
              style={{ backgroundColor: person.avatarColor || '#6B7F4A' }}
            >
              {person.firstName?.[0]?.toUpperCase() || '?'}
            </span>
            <span className="font-serif text-sm text-gray-800">{person.firstName}</span>
            <button
              onClick={() => onRemovePerson(person.id)}
              className="text-gray-400 hover:text-gray-600 ml-0.5"
            >
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </span>
        ))}
      </div>

      <span className="font-serif text-sm text-gray-600 whitespace-nowrap">
        {filteredStoryCount} {filteredStoryCount === 1 ? 'story' : 'stories'}
      </span>

      <button
        onClick={onClearAll}
        className="font-serif text-sm text-fb-olive font-semibold hover:underline whitespace-nowrap"
      >
        Show All Stories
      </button>
    </div>
  )
}

export default ActiveFilterBar
